import React from "react";

const TILES = [
  { key: "open", label: "Open", tone: "text-blue-600 bg-blue-50" },
  { key: "in_progress", label: "In Progress", tone: "text-violet-600 bg-violet-50" },
  { key: "pending_client", label: "Pending Client", tone: "text-amber-600 bg-amber-50" },
  { key: "completed", label: "Completed", tone: "text-emerald-600 bg-emerald-50" },
  { key: "all", label: "Total", tone: "text-slate-600 bg-slate-100" },
];

export default function MetricsPanel({ metrics }) {
  if (!metrics) return null;
  const t = metrics.totals || {};
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
        {TILES.map(({ key, label, tone }) => (
          <div key={key} className="surface-card p-5">
            <div className={`w-10 h-10 rounded-xl flex items-center justify-center ${tone} text-[10px] font-bold uppercase`}>{label.slice(0, 2)}</div>
            <div className="mt-4 font-display text-3xl font-bold text-slate-900 tabular-nums tracking-tight">{t[key] ?? 0}</div>
            <div className="text-[10px] uppercase tracking-[0.15em] text-slate-400 font-semibold mt-1">{label}</div>
          </div>
        ))}
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <div className="surface-card p-5">
          <div className="text-[10px] uppercase tracking-[0.15em] text-slate-400 font-semibold">Avg. resolution</div>
          <div className="mt-1 font-display text-3xl font-bold tabular-nums">
            {metrics.avg_resolution_hours ?? 0}
            <span className="text-sm text-slate-500 ml-1">{metrics.hours_basis === "business" ? "business hrs" : "hrs"}</span>
          </div>
        </div>
        <div className="surface-card p-5">
          <div className="text-[10px] uppercase tracking-[0.15em] text-slate-400 font-semibold">Completion ratio</div>
          <div className="mt-1 font-display text-3xl font-bold tabular-nums">
            {metrics.completion_ratio ?? 0}
            <span className="text-sm text-slate-500 ml-1">%</span>
          </div>
        </div>
      </div>
    </div>
  );
}
